module.exports = __webpack_public_path__ + "img/default-homepage-reviews-black.eda4b440.png";